/**
 * Bilingual tour copy (es/fr/zh/hi fall back to English via t()).
 * @deprecated Use page-level supplements via tourLocaleSupplements.js instead.
 *
 * @type {Record<string, Record<string, { title?: Record<string,string>, body?: Record<string,string> }>>}
 */
export const TOUR_STEP_OVERLAYS = {
  es: {},
  fr: {},
  zh: {},
  hi: {},
};

/**
 * @param {import('./types.js').TourStep[]} steps
 * @param {string} locale
 */
export function applyTourOverlays(steps, locale) {
  const overlay = TOUR_STEP_OVERLAYS[locale];
  if (!overlay) {
    return steps;
  }
  return steps.map((step) => {
    const patch = overlay[step.id];
    if (!patch) {
      return step;
    }
    return {
      ...step,
      title: patch.title ? { ...step.title, ...patch.title } : step.title,
      body: patch.body ? { ...step.body, ...patch.body } : step.body,
    };
  });
}
